export default {
  mutations: {
    SET_SINGLE_COMPANY_USER: 'SET_SINGLE_COMPANY_USER',
    SET_SEARCH_USER: 'SET_SEARCH_USER',
  },
  getters: {
    GET_SINGLE_COMPANY_USER: 'GET_SINGLE_COMPANY_USER',
  },
  actions: {
    SINGLE_COMPANY_USER: 'SINGLE_COMPANY_USER',
    UPDATE_COMPANY_USER: 'UPDATE_COMPANY_USER',
    DELETE_COMPANY_USER: 'DELETE_COMPANY_USER',
    SAVE_COMPANY_USER: 'SAVE_COMPANY_USER',
    SEARCH_USER: 'SEARCH_USER',
  },
};
